import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, withRouter, useLocation } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomePage from "../pages/home/HomePage";
import AuthPage from "../pages/auth/AuthPage";
import SuccessPage from "../pages/auth/Success";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import CustomSnackbar from "../partials/content/Snackbar";
import { getCsrfToken } from '@utils/common';

export const Routes = withRouter(({ history }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [tokenExpired, setTokenExpired] = useState(false);
  const location = useLocation();
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);

  const { filter, menuConfig, userLastLocation, user } = useSelector(
    ({ auth, filter, builder: { menuConfig } }) => ({
      filter,
      menuConfig,
      userLastLocation: routerHelpers.getLastLocation(),
      user: auth.user
    }),
    shallowEqual
  );

  useEffect(() => {
    const checkAuthStatus = async (retryCount = 7, delay = 500) => {
      for (let attempt = 0; attempt < retryCount; attempt++) {
        try {
          const response = await fetch("/api/user/me", {
            method: "GET",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": getCsrfToken(),
            }
          });

          if (!response.ok) throw new Error("Unauthorized");

          const user = await response.json();
          setIsAuthorized(true);

          if (user.exp && user.exp < Date.now() / 1000) {
            setTokenExpired(true);
          } else {
            setTokenExpired(false);
          }
          return;
        } catch (error) {
          console.log(`Auth check failed (attempt ${attempt + 1}/${retryCount})`);
          if (attempt < retryCount - 1) {
            await new Promise(resolve => setTimeout(resolve, delay));
          } else {
            setIsAuthorized(false);
          }
        }
      }
    };

    checkAuthStatus();
  }, []);


  return (
    <div
      style={{
        background: filter.theme === 'dark' ? filter.darkBackground : filter.lightBackground,
        minHeight: '100%',
      }}
    >
      <div
        style={{
          background: filter.theme === 'dark' ? filter.darkBackground : filter.lightBackground,
          height: 'auto',
        }}
      >
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
          <CustomSnackbar />
          <Switch>
            {!isAuthorized ? (
              <>
                <Route path="/auth/success" component={SuccessPage} />
                <Route path="/auth/login" component={AuthPage} />
                {location.pathname !== "/auth/success" && location.pathname !== "/auth/login" && (
                  <Redirect to={{ pathname: "/auth/login", search: location.search }} />
                )}
              </>
            ) : (
              <Redirect from="/auth" to={{ pathname: userLastLocation, search: location.search }} />
            )}

            <Route path="/error" component={ErrorsPage} />
            <Route path="/logout" component={LogoutPage} />

            {!isAuthorized ? (
              <Redirect to={{ pathname: "/auth/login", search: location.search }} />
            ) : tokenExpired ? (
              <Redirect to={{ pathname: "/logout", search: location.search }} />
            ) : (
              <Layout>
                <HomePage userLastLocation={userLastLocation} />
              </Layout>
            )}
          </Switch>
        </LayoutContextProvider>
      </div>
    </div>
  );
});
